// extracted by mini-css-extract-plugin
export var createdDate = "_nd-1";
export var divider = "_nd-2";
export var headerDivider = "_nd-3";
export var messagesCard = "_nd-0";
export var messagesContainer = "_nd-7";
export var messagesContainerWrapper = "_nd-4";
export var pointerCapturingButtonBoxes = "_nd-a";
export var showLeftPanelButton = "_nd-9";
export var showMoreButton = "_nd-c";
export var showMoreButtonContainer = "_nd-b";
export var summaryTitle = "_nd-6";
export var systemMessageCardWrapper = "_nd-d";
export var topButtons = "_nd-8";
export var withPadding = "_nd-5";